/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import React from 'react';

import ClearIcon from '@mui/icons-material/Clear';
import { Badge, BadgeProps, IconButton, IconButtonProps } from '@mui/material';

import { useDeletableThumbnailBadgeStyles } from './DeletableThumbnailBadge.styles';

type DeletableThumbnailBadgeProps = Omit<BadgeProps, 'anchorOrigin' | 'badgeContent'> &
  Pick<IconButtonProps, 'disabled'> & {
    thumbnail: React.ReactNode;
    onDelBtnClick: IconButtonProps['onClick'];
  };

export function DeletableThumbnailBadge(props: DeletableThumbnailBadgeProps) {
  const classes = useDeletableThumbnailBadgeStyles();
  const { onDelBtnClick, disabled, thumbnail, ...otherProps } = props;

  return (
    <Badge
      {...otherProps}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      badgeContent={
        <IconButton
          onClick={onDelBtnClick}
          size="small"
          classes={{ root: classes.deleteIcon }}
          disabled={disabled}
          data-cy="delete-thumbnail-button"
        >
          <ClearIcon fontSize="small" />
        </IconButton>
      }
    >
      {thumbnail}
    </Badge>
  );
}
